export const appRoutes = {
  dashboard: {
    label: "Главная",
    value: "dashboard",
  },
  remarks: {
    label: "Ошибки в товарах",
    value: "remarks",
  },
  complaints: {
    label: "Жалобы",
    value: "complaints",
  },
  notifications: {
    label: "Уведомления",
    value: "notifications",
  },
  notificationsForm: {
    label: "Создать рассылку",
    value: "notificationsForm",
  },
  suggestions: {
    label: "Шаблоны",
    value: "suggestions",
  },
  chat: {
    label: "Сообщения",
    value: "chat",
  },
  receipts: {
    label: "Чеки заказов",
    value: "receipts",
  },
  bundles: {
    label: "Бандлы",
    value: "bundles",
  },
  chatStats: {
    label: "Статистика",
    value: "chat/stats",
  },
  users: {
    label: "Пользователи",
    value: "users",
  },
  promo: {
    label: "Акционные товары",
    value: "promo",
  },
  tags: {
    label: "Теги",
    value: "tags",
  },
  roles: {
    label: "Роли",
    value: "roles",
  },
  permissions: {
    label: "Доступы в разделы",
    value: "permissions",
  },
  reviews: {
    label: "Отзывы",
    value: "reviews",
  },
  coupons: {
    label: "Купоны",
    value: "coupons",
  },
  fastOrderLinks: {
    label: "Быстрые заказы",
    value: "fastOrdersLinks",
  },
};

export const normalizeRoutePath = (path = "") => path.replace(/^\/+/, "");
